const map_config = {
    "thresholds": 
        [
            {
                "threshold": -1,
                "rgb" : [0,0,0] 
            },
            {
                "threshold": 30,
                "rgb": [0, 201, 232]
            },
            {
                "threshold": 50,
                "rgb": [255, 255, 0]
            },
            {
                "threshold": 80,
                "rgb": [255, 128, 0]
            },  
            {
                "threshold": 10000,
                "rgb": [255, 0, 0]
            }            
        ],
    "image_size":{
        "max_width": 1000,
        "max_height": 500
    },
    "canvas_size":{
        "max_width": 1000,
        "max_height": 500
    },
    "map_max":[
        5, 10, 15
    ],
    "fav_max":[
        3, 7, 10
    ]
}
// console.log("Map Config Loaded", map_config)
export default map_config